/*
 * @Author: 李嘉宾 lijb@wisea.com.cn
 * @Date: 2024-07-16 10:32:43
 * @LastEditors: 李嘉宾 lijb@wisea.com.cn
 * @LastEditTime: 2024-08-27 16:48:10
 * @FilePath: \web\sznc_buyer\src\router\mallRoutes\modules\dealhome.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
export default [{
    path: 'editOrder',
    name: {list:['提交订单']},
    component: () => import('@/view/dealhome/editOrder.vue')
  },
  {
    path: 'payOrder',
    name: {list:['收银台']},
    component: () => import('@/view/dealhome/payOrder.vue')
  },
  {
    path: 'payOrders',
    name: {list:['对公支付']},
    component: () => import('@/view/dealhome/payOrders.vue')
  },
  {
    path: 'payOrderxzf',
    name: {list:['线下支付']},
    component: () => import('@/view/dealhome/payOrderxzf.vue')
  },
    {
    path: 'transferOrder',
    name: {list:['转账支付']},
     component: () => import('@/view/dealhome/transferOrder.vue')
  },
  {
    path: 'payOver',
    name: {list:['个人中心']},
    component: () => import('@/view/dealhome/payOver.vue')
  },
  {
    path: 'shopCart',
    name: {title:'购物车'},
    component: () => import('@/view/myCart/shopCart.vue')
  },
  // {
  //   path: 'goodsDetails',
  //   name: '首页-商品详情页',
  //   component: () => import('@/view/dealhome/goodsDetails.vue')
  // },
  {
    path: 'goodsList',
    name: '首页-筛选页',
    component: () => import('@/view/dealhome/goodsList.vue')
  },
  {
    path: 'submitSussLarge',
    name: {list:['商家确认']},
    component: () => import('@/view/dealhome/submitSussLarge.vue')
  },
  {
    path: 'shopIndex',
    name: {list:['店铺首页']},
    component: () => import('@/view/dealhome/shopIndex.vue')
  },
  {
    path: 'zqpayOver',
    name: {list:['支付成功']},
    component: () => import('@/view/dealhome/zqpayOver.vue')
  },
  {
    path: 'preferredBase',
    name: {list:['优选基地']},
    component: () => import('@/view/dealhome/preferredBase.vue')
  },
  {
    path: 'baseDetails',
    name: {list:['基地详情']},
    component: () => import('@/view/dealhome/baseDetails.vue')
  },
  {
    path: 'testService',
    name: {list:['检测服务']},
    component: () => import('@/view/dealhome/testService.vue')
  },
  {
    name: "商城首页",
    path: "",
    component: () => import("@/view/shopDecoration/views/index.vue"),
  },
  {
    name: "商城专题页",
    path: "special",
    component: () => import("@/view/shopDecoration/views/special.vue"),
  },
  {
    path: 'standard',
    name: {list:['道地药库']},
    component: () => import('@/view/dealhome/standard/standard.vue')
  },
  {
    path: 'information',
    name: {list:['资讯']},
    component: () => import('@/view/information/index.vue')
  },
  {
    path: 'newsDetail',
    name: {list:['资讯详情']},
    component: () => import('@/view/information/details.vue')
  },
  {
    path: 'aboutUs',
    name: {list:['关于我们']},
    component: () => import('@/view/aboutUs/aboutUs.vue')
  },
  {
    path: '/varieties',
    name: '品种列表',
    component: () => import('@/view/varieties/index.vue')
  },
  {
    path: '/varietiesDetails',
    name: '品种详情',
    component: () => import('@/view/varieties/details.vue')
  },
  {
    path: '/logisticServ',
    name: '物流服务',
    component: () => import('@/view/logisticServ/index.vue')
  },
]